/* Free PHOLOH Bag — one in every order, added automatically.
 *
 * RULES (Diego 2026-09-13, removal fixed 2026-09-14):
 *   cart has any other product      -> exactly one bag is present
 *   cart has nothing but OUR bag    -> the bag is removed ("it has to be removed with the product")
 *   cart has a bag the SHOPPER added-> hands off entirely (they are buying bags)
 *
 * 🚨 THIS IS A SEPARATE FILE FROM pholoh-free-keychain.js ON PURPOSE.
 * That script charged 38 customers $12 each: it only ever ADDS, the discount is what made
 * the item free, and when "BTS FREE KEYCHAIN" was switched off the adds kept happening at
 * full price. Reviving that file would risk switching the keychain back on with it. This one
 * is bag-only and carries the guard that was missing.
 *
 * ⭐ THE GUARD. If a bag WE added reads a non-zero final price WHILE OTHER ITEMS ARE IN THE
 * CART, the discount is off or broken: pull our line and stop adding for this session. A
 * shopper is never charged for a bag we put in their cart. `endsAt` on the discount is null
 * (permanent by design), so this guard is what makes that safe — see [[bts-free-keychain-promo]].
 *
 * 🚨 2026-09-14 BUG THIS VERSION FIXES. The bag is only free while something else is in the
 * cart (BXGY "buy 1 from All Products"). Removing the last product made the bag read $18, the
 * guard fired, and it set STOP for the whole session — so every later add in that visit got
 * no bag and nothing was cleaned up again. Ownership also lived in sessionStorage, so a cart
 * carried over from an earlier visit had an "unknown" bag that was never removed and sat in
 * the drawer at $18 (Diego's screenshot). Now:
 *   - "nothing else in the cart" is handled FIRST and never trips the guard or STOP;
 *   - ownership is remembered per CART TOKEN in localStorage, so it survives new visits;
 *   - a bag the shopper adds themselves (any /cart/add carrying the bag variant that did not
 *     come from this script) is marked as theirs and left alone.
 *
 * WHY A fetch WRAPPER. Items reach the cart from at least five places on this site (product
 * form, quick-add, sticky ATC, cart-drawer upsell, Finish the Fit). Wrapping fetch catches
 * anything that talks to /cart/*, including code written later that knows nothing about this.
 *
 * 🚨 THE LOCK SPANS THE READ, NOT JUST THE WRITE. One add fires several triggers at once, so
 * two passes can both read "no bag" and both add one. The lock is taken before the read and
 * released after the write. Triggers are also debounced into a single pass.
 */
(function () {
  var BAG_VARIANT = 43109011062845;          /* PH-0774, "PHOLOH" Bag, $18 */
  var FAIL_LIMIT = 3;
  var OWN_KEY = 'pholohFreeBagOwnedCart';    /* localStorage: cart token whose bag WE added */
  var MINE_KEY = 'pholohBagChosenCart';      /* localStorage: cart token where the SHOPPER added a bag */
  /* sessionStorage: discount looked broken this visit. RENAMED 09-14: the old key was set by the
     removal bug on perfectly healthy carts, and keeping the name would leave those visits stuck. */
  var STOP_KEY = 'pholohFreeBagStop2';
  var busy = false, fails = 0, timer = null, ourAdd = false;

  function ls(k, v) {
    try { if (v === undefined) { return localStorage.getItem(k); }
          if (v === null) { localStorage.removeItem(k); } else { localStorage.setItem(k, v); } }
    catch (e) { return null; }
  }
  function stopped() { try { return sessionStorage.getItem(STOP_KEY) === '1'; } catch (e) { return false; } }
  function stop() { try { sessionStorage.setItem(STOP_KEY, '1'); } catch (e) {} }

  function post(url, body) {
    return _fetch('/cart/' + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { if (!r.ok) { fails++; } return r.json().catch(function () { return {}; }); })
      .catch(function () { fails++; })
      .then(function () { document.dispatchEvent(new CustomEvent('cart:build')); });
  }

  function reconcile() {
    if (busy || fails >= FAIL_LIMIT) return;
    busy = true;                                   /* held across read AND write */
    return _fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var token = cart.token || '';
        var bag = null, others = 0;
        (cart.items || []).forEach(function (i) {
          if (i.variant_id === BAG_VARIANT) { bag = bag || i; }
          else { others += i.quantity; }
        });
        /* Carry over a bag the previous version added in this visit (it kept ownership in
           sessionStorage under the old key). */
        try {
          if (bag && token && sessionStorage.getItem('pholohFreeBagOwned') === '1') {
            ls(OWN_KEY, token); sessionStorage.removeItem('pholohFreeBagOwned');
          }
        } catch (e) {}
        var ours = !!bag && !!token && ls(OWN_KEY) === token;
        var shopperChose = !!token && ls(MINE_KEY) === token;
        /* A single bag with NO record either way predates this version (e.g. a cart carried over
           from an earlier visit — Diego's leftover $18 bag). The free bag is the only way a lone
           single bag normally gets there, so treat it as ours when nothing else is left. */
        var unclaimedLone = !!bag && !ours && !shopperChose && bag.quantity === 1;

        /* 1. Nothing else left: our bag goes with the last product. Checked FIRST, so the
              bag reading $18 here (it is only free next to a product) never trips the guard. */
        if (others === 0) {
          if (bag && (ours || unclaimedLone) && !shopperChose) {
            ls(OWN_KEY, null);
            return post('change.js', { id: bag.key, quantity: 0 });
          }
          return;
        }

        /* 1b. HALLOWEEN 2026 LIVE (10-23): the bag BXGY needs a "buy" line, and Shopify gives each line ONE product
              discount, so a bag in the cart either costs $18 or STRIPS the sale % off one item (cart-tested: Tyrant
              hoodie $66.30 alone -> $78 + $0 bag; Ghoul set + bag -> bag $18). While the sale is live we never add the
              bag and we pull ours; the droplet sweep add_free_bag.py (every 15 min) still adds it to every order at $0 after
              checkout, so every order still ships with the bag. Reverts by itself when hw-state leaves 'live'. */
        if (window.PHOLOH_HW && window.PHOLOH_HW.state === 'live') {
          if (bag && (ours || unclaimedLone) && !shopperChose) {
            ls(OWN_KEY, null);
            return post('change.js', { id: bag.key, quantity: 0 });
          }
          return;
        }

        /* 2. THE CHARGE GUARD — only meaningful while a qualifying product is in the cart. */
        if (bag && ours && Number(bag.final_line_price) > 0) {
          stop(); ls(OWN_KEY, null);
          return post('change.js', { id: bag.key, quantity: 0 });
        }

        /* 3. A product is in the cart and there is no bag: add ours (unless the discount
              already looked broken this visit). */
        if (!bag && !stopped()) {
          if (token) ls(OWN_KEY, token);
          ourAdd = true;
          return post('add.js', { items: [{ id: BAG_VARIANT, quantity: 1 }] })
            .then(function () { ourAdd = false; });
        }
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(reconcile, 150); }

  /* A bag added by anything other than this script is the shopper's own choice. */
  function noteShopperBag(input, init) {
    if (ourAdd) return;
    var body = init && init.body;
    if (typeof body !== 'string' || body.indexOf(String(BAG_VARIANT)) === -1) return;
    _fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c.token) { ls(MINE_KEY, c.token); ls(OWN_KEY, null); } })
      .catch(function () {});
  }

  var _fetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var out = _fetch.apply(window, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
      if (/\/cart\/add/.test(url)) { out.then(function () { noteShopperBag(input, init); }).catch(function () {}); }
      if (!busy) { out.then(function () { schedule(); }).catch(function () {}); }
    }
    return out;
  };

  document.addEventListener('cart:updated', schedule);
  document.addEventListener('ajaxProduct:added', schedule);

  if (document.readyState !== 'loading') { schedule(); }
  else { document.addEventListener('DOMContentLoaded', schedule); }
})();
